import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component PeopleIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <PeopleIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <PeopleIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const PeopleIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="PeopleIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="m20.998 16.775-.148-.387a2 2 0 0 0-1.601-1.27 13 13 0 0 0-2.317-.105c-.253-.76-.683-1.527-.932-1.937a15 15 0 0 1 3.518.06 4 4 0 0 1 3.203 2.54l.147.387a2 2 0 0 1-1.614 2.696 28 28 0 0 1-3.248.24c0-.355-.004-.741-.127-1.115L17.587 17a27 27 0 0 0 3.41-.225zM17.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 2a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7M5.437 14.315a2 2 0 0 0-1.494 1.333L3 18.51q2.739.49 5.473.49a31 31 0 0 0 5.474-.49l-.943-2.862a2 2 0 0 0-1.494-1.333A15 15 0 0 0 8.473 14q-1.514 0-3.036.315m-.406-1.958A17 17 0 0 1 8.473 12q1.722 0 3.443.357a4 4 0 0 1 2.987 2.665l.943 2.862A2 2 0 0 1 14.3 20.48a33 33 0 0 1-5.827.52q-2.912 0-5.825-.521a2 2 0 0 1-1.547-2.595l.942-2.862a4 4 0 0 1 2.988-2.665M8.474 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0 2a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9" />
      <path
        stroke="#F4F5F7"
        strokeWidth={0.1}
        d="M.05.05h23.9v23.9H.05z"
        opacity={0.01}
      />
    </svg>
  )
);
PeopleIcon.displayName = "PeopleIcon";
export default PeopleIcon;
